import React from 'react'
import { useTranslation } from 'react-i18next'
import AuthPage from '../../../common/AuthPage/AuthPage'
import ContentWrapper from '../../../common/ContentWrapper/ContentWrapper'
import LoginForm from '../LoginForm/LoginForm'

// Страница с формой входа
function LoginPage() {
	const { t } = useTranslation()

	return (
		<AuthPage>
			<ContentWrapper header={t('auth.loginPageHeader')}>
				<LoginForm />
			</ContentWrapper>
		</AuthPage>
	)
}

export default LoginPage
